export default "__VITE_ASSET__fcd78ef8__"